import { render, staticRenderFns } from "./TickerDetails.vue?vue&type=template&id=1f55a5d6&scoped=true"
import script from "./TickerDetails.vue?vue&type=script&lang=ts"
export * from "./TickerDetails.vue?vue&type=script&lang=ts"
import style0 from "./TickerDetails.vue?vue&type=style&index=0&id=1f55a5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f55a5d6",
  null
  
)

export default component.exports